import { RenderControl } from '@fareye/ui'
import React from 'react'
import { TimeZoneProvider, useMapper, useTimer } from '@fareye/common'
import { ITripDetailsMapper } from '../../utility/types'
import { MultiModelHistory } from '..'
import version from '../../config/npmVersions'
//NOTE: This config is used to render this Route Listing we will move this to server.

export default function MultiModelHistoryMapper(props: ITripDetailsMapper) {
  const [apiData, _] = useMapper({ ...props, version })
  const { minAutoRefreshInterval, refreshTimeInterval } =
    apiData?.data?.config?.config || {}
  let { maxRefreshCount, refreshInterval } = props
  refreshInterval = refreshInterval ? refreshInterval : refreshTimeInterval
  const [timer] = useTimer({
    maxRefreshCount,
    refreshInterval,
    minAutoRefreshInterval
  })
  return (
    <TimeZoneProvider>
      <RenderControl variant="m" state={apiData}>
        <MultiModelHistory
          {...props}
          timer={timer as number}
          config={apiData.data as any}
        />
      </RenderControl>
    </TimeZoneProvider>
  )
}
